import { TransportType } from 'types/transport';
import { useDirection } from 'components/map/map-container/hooks/use-direction';
import { useInitMap } from 'components/map/map-container/hooks/use-init-map';
import { useSetTransportsMarkers } from 'components/map/map-container/hooks/use-set-transports-markers';
import { Direction } from './direction-data/direction-data-service';
import { useSetAnonymousWaypointsMarkers } from './hooks/use-set-anonymous-waypoints-markers';
import type { IClientCargoMapContainerProps } from './types';

export const ClientCargoMapContainer: React.FC<IClientCargoMapContainerProps> = (props) => {
  const { waypoints, transport } = props;

  const transports = transport ? [{ ...transport, type: TransportType.truck }] : [];

  const { map, mapBoxRef } = useInitMap();

  useSetAnonymousWaypointsMarkers({ map, waypoints });

  useSetTransportsMarkers({ map, transports });

  const directionDataService = new Direction({ waypoints });

  useDirection({ map, directionDataService });

  return <div ref={mapBoxRef} style={{ width: '100%', height: '500px' }} />;
};
